/// <reference path="./deepLinkInterfaces.ts"/>
class DeepLinkController {
    constructor(
        $rootScope: ng.IRootScopeService,
        deepLinkService: DeepLink.IDeepLinkService,
        $location: ng.ILocationService,
        searchQueryString
    ) {
        $rootScope.$emit('block', {});
        $location.replace();
        const reqParams = searchQueryString.getDeepLinkQSParams();
        deepLinkService.getSearchDeepLink(reqParams)
            .then((deepLinkUrl) => {
                $location.replace();
                const {pathnameWithoutCulture} = deepLinkService.parseFullUrl(deepLinkUrl);
                $location.url(pathnameWithoutCulture);
                $rootScope.$apply();
            });
    }
}

angular
    .module('deepLink')
    .controller('DeepLinkController', DeepLinkController);
